// Archive loading is asynchronous. Keep its compensation tied to where the
// reader is now, rather than where they were when the request started. Once
// the response is ready, offsets can include new rows even if virtual spacers
// shrink; freeze the baseline so insertion is compensated only once.
export function trackChatPrependScroll(prepend, {
  offset,
  contentHeight,
  element,
  now = Date.now(),
}) {
  if (!prepend || prepend.requestPending === false || now > prepend.until
    || !Number.isFinite(offset) || !Number.isFinite(contentHeight)
    || contentHeight > prepend.prevHeight + 1) return;
  prepend.prevOffset = Math.max(0, offset);
  // VirtualizedList can change estimated spacers below the reader while
  // inserting history above them. Remember the actual visible row so total
  // content growth cannot be mistaken for the height added above it.
  const rows = element?.querySelectorAll?.('[id^="msg-hl-"]');
  if (!rows?.length) return;
  const viewportTop = element.getBoundingClientRect().top;
  let lo = 0;
  let hi = rows.length - 1;
  let node = null;
  while (lo <= hi) {
    const mid = (lo + hi) >> 1;
    if (rows[mid].getBoundingClientRect().bottom > viewportTop + 1) {
      node = rows[mid];
      hi = mid - 1;
    } else lo = mid + 1;
  }
  prepend.rowAnchor = node ? { node, top: node.getBoundingClientRect().top - viewportTop } : null;
}

export function getChatPrependOffset(prepend, { contentHeight, element }) {
  const anchor = prepend.rowAnchor;
  if (element && anchor?.node.isConnected && element.contains(anchor.node)) {
    const top = anchor.node.getBoundingClientRect().top - element.getBoundingClientRect().top;
    return Math.max(0, element.scrollTop + top - anchor.top);
  }
  // Native lists and unmounted web anchors retain the offset compensation.
  return Math.max(0, prepend.prevOffset + contentHeight - prepend.prevHeight);
}
